<template>
  <div class="validar-pago">
    <modal-pdf :urlDocumento="urlPdf"></modal-pdf>
    <!-- Modal anotar observación -->
    <div
      class="modal fade"
      id="modalObservacion"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header header-observacion">
            <h5 class="modal-title titulo-observacion">
              Ingresa la observación
            </h5>
          </div>
          <div class="modal-body">
            <div class="col-md-12" v-if="ObservacionArchivo != null">
              <label class="font-weight-bold obs-actual"
                >Observación actual:
              </label>
            </div>
            <textarea
              class="form-control texto-observacion"
              v-model="Observacion.motivoObservacion"
              rows="2"
            ></textarea>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn boton-cancelar-obs"
              data-bs-dismiss="modal"
              ref="botoncerrarObservacion"
              @click.prevent="LimpiarCamposModal()"
            >
              Cancelar
            </button>
            <button
              v-if="enviandoObservacion"
              disabled
              class="btn boton-primario boton-aceptar-obs"
            >
              <v-progress-circular
                indeterminate
                size="30"
                color="primary"
              ></v-progress-circular>
            </button>
            <button
              v-else
              type="button"
              @click.prevent="EnviarObservacionArchivo"
              class="btn boton-primario boton-aceptar-obs"
            >
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>
    <TituloSeccion titulo="VALIDACIÓN DE PAGO" />
    <div class="container form-container">
      <div class="row col-lg-12" style="text-align: left">
        <p class="parrafo-instrucciones mt-2">
          Revisa los documentos cargados y agrégales una observación en caso de
          que requieran una mejora o cambio.
        </p>
      </div>
      <div
        class="row align-center"
        style="min-height: 200px;"
        v-if="cargandoInfoPago"
      >
        <div class="text-center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
          <p class="my-3">Cargando</p>
        </div>
      </div>
      <div v-if="ArchivosExpediente.length > 0 && !cargandoInfoPago">
        <div class="table-responsive" v-if="ArchivosExpediente.length > 0">
          <table class="table tabla-preautorizacion">
            <thead class="encabezado-tabla">
              <tr>
                <th scope="col">Documento</th>
                <th scope="col">Archivo</th>
                <th scope="col">Observación</th>
                <th scope="col">Descargar</th>
                <th scope="col">Aprobar</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="archivo in ArchivosExpediente"
                :key="archivo.archivoId"
                class="mt-3"
              >
                <td class="texto-tabla">
                  {{
                    archivo.tipoDocumentoStr.charAt(0).toUpperCase() +
                      archivo.tipoDocumentoStr.slice(1)
                  }}
                </td>
                <td class="texto-tabla-archivo">
                  {{ archivo.documentoStr }}
                </td>
                <td
                  v-if="archivo.esAprobado == false"
                  class="texto-tabla-obs"
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  @click.prevent="RechazarArchivo(archivo.archivoId)"
                >
                  Ver observación
                </td>
                <td
                  v-else
                  class="texto-tabla-obs"
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  @click.prevent="RechazarArchivo(archivo.archivoId)"
                >
                  + Agregar una observación
                </td>
                <td>
                  <i
                    v-on:click="descargarArchivo(archivo.archivoId)"
                    class="fa fa-download iconoArchivo-png"
                  ></i>
                  <i
                    v-if="archivo.extension == '.PDF'"
                    data-bs-toggle="modal"
                    data-bs-target="#modalPdf"
                    v-on:click="VerArchivo(archivo.archivoId)"
                    class="fa fa-eye iconoVer-png"
                  ></i>
                </td>
                <td
                  v-if="archivo.esAprobado == false"
                  class="texto-tabla-obs"
                  @click.prevent="AprobarArchivo(archivo.archivoId, 0)"
                >
                  Aprobar
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--ESTO SOLO SE MUESTRA EN MOVIL-->
        <div
          class="listado-documentos-movil"
          v-if="ArchivosExpediente.length > 0"
        >
          <div
            class="row col-lg-12"
            v-for="archivo in ArchivosExpediente"
            :key="archivo.archivoId"
          >
            <strong
              class="titulo-seccion documento-movil"
              style="margin-right: 10px"
            >
              {{
                archivo.tipoDocumentoStr.charAt(0).toUpperCase() +
                  archivo.tipoDocumentoStr.slice(1)
              }}
            </strong>
            <div class="row col-12" style="margin-top: -10px">
              <div class="col-10" style="text-align: initial">
                <label class="texto-tabla-obs">
                  {{ archivo.nombreOriginal }}
                </label>
                <label
                  v-if="archivo.esAprobado == false"
                  class="texto-tabla-obs"
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  @click.prevent="RechazarArchivo(archivo.archivoId)"
                >
                  Ver observación
                </label>
                <label
                  v-else
                  class="texto-tabla-obs"
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  @click.prevent="RechazarArchivo(archivo.archivoId)"
                >
                  + Agregar una observación
                </label>
                <label
                  v-if="archivo.esAprobado == false"
                  class="texto-tabla-obs"
                  @click.prevent="AprobarArchivo(archivo.archivoId, 0)"
                  style="display: block"
                >
                  Aprobar
                </label>
              </div>
              <div class="col-2">
                <i
                  v-if="archivo.extension == '.PDF'"
                  data-bs-toggle="modal"
                  data-bs-target="#modalPdf"
                  v-on:click="VerArchivo(archivo.archivoId)"
                  class="fa fa-eye iconoVer-png"
                ></i>
                <i
                  v-on:click="descargarArchivo(archivo.archivoId)"
                  class="fa fa-download iconoArchivo-png"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="comprobantePagoCliente.comprobatePagoPdf.nombreCliente">
        <!-- Aqui empieza la tabla de pagos online -->
        <div
          class="table-responsive"
          v-if="comprobantePagoCliente.comprobatePagoPdf.nombreCliente"
        >
          <table class="table tabla-preautorizacion">
            <thead class="encabezado-tabla-comprobante">
              <tr>
                <th scope="col">Nombre cliente</th>
                <th scope="col">No. Operación</th>
                <th scope="col">No. Autorización</th>
                <th scope="col">Fecha</th>
                <th scope="col">Tipo de tarjeta</th>
                <th scope="col">Monto</th>
                <th scope="col">Promoción</th>
                <th scope="col">Descargar</th>
              </tr>
            </thead>
            <tbody>
              <tr class="mt-3">
                <td class="texto-tabla-comprobante">
                  {{ comprobantePagoCliente.comprobatePagoPdf.nombreCliente }}
                </td>
                <td class="texto-tabla-comprobante">
                  {{ comprobantePagoCliente.comprobatePagoPdf.foliocpagos }}
                </td>

                <td class="texto-tabla-comprobante">
                  {{ comprobantePagoCliente.comprobatePagoPdf.auth }}
                </td>
                <td class="texto-tabla-comprobante">
                  {{
                    formatoFecha(comprobantePagoCliente.comprobatePagoPdf.fecha)
                  }}
                </td>

                <td class="texto-tabla-comprobante">
                  {{ comprobantePagoCliente.comprobatePagoPdf.cc_type }}
                </td>
                <td class="texto-tabla-comprobante">
                  {{
                    formatoMoneda(
                      comprobantePagoCliente.comprobatePagoPdf.amount
                    )
                  }}
                </td>
                <td class="texto-tabla-comprobante">
                  {{ comprobantePagoCliente.comprobatePagoPdf.promocion }}
                </td>

                <td class="texto-tabla-comprobante">
                  <i
                    v-on:click="
                      descargarPdf(
                        comprobantePagoCliente.fileContent,
                        comprobantePagoCliente.fileName
                      )
                    "
                    class="fa fa-download iconoArchivo-png"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--ESTO SOLO SE MUESTRA EN MOVIL PAGOS ONLINE-->
        <div
          class="listado-documentos-movil"
          v-if="comprobantePagoCliente.comprobatePagoPdf.nombreCliente"
        >
          <div class="row col-lg-12">
            <strong
              class="titulo-seccion documento-movil"
              style="margin-right: 10px"
            >
              Comprobante de pago
            </strong>
            <div class="row col-12 align-center" style="margin-top: -10px">
              <div class="col-10" style="text-align: initial">
                <label class="texto-tabla-obs">
                  {{ comprobantePagoCliente.comprobatePagoPdf.nombreCliente }}
                </label>
              </div>
              <div class="col-2">
                <i
                  v-on:click="
                    descargarPdf(
                      comprobantePagoCliente.fileContent,
                      comprobantePagoCliente.fileName
                    )
                  "
                  class="fa fa-download iconoArchivo-png"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row align-center"
        style="border: 1px solid #b8725a; height: 200px;"
        v-else-if="
          (ArchivosExpediente.length === 0 && !cargandoInfoPago) ||
            (!comprobantePagoCliente.comprobatePagoPdf.nombreCliente &&
              !cargandoInfoPago)
        "
      >
        <p>No se encontró ningún documento.</p>
      </div>
      <div
        class="row row-cols-lg-12"
        style="justify-content: flex-end"
        v-if="ArchivosExpediente.length > 0"
      >
        <strong
          class="w-auto etiqueta-nuevo-documento mt-3 mb-3"
          v-on:click="descargarTodosLosArchivos()"
          >Descargar todos los archivos</strong
        >
      </div>
      <div
        class="row row-cols-lg-12 mt-6"
        v-if="
          ArchivosExpediente.length > 0 ||
            comprobantePagoCliente.comprobatePagoPdf.nombreCliente
        "
      >
        <div class="col-lg-6">
          <button
            v-if="rechazandoComprobante"
            disabled
            style="height: 50px"
            class="btn boton-transparente w-100"
          >
            <v-progress-circular
              indeterminate
              size="30"
              color="#b8725a"
            ></v-progress-circular>
          </button>
          <button
            v-else
            style="height: 50px"
            class="btn boton-transparente w-100"
            v-on:click="rechazarComprobanteYEnviarACorreccion"
          >
            Rechazar y enviar a corrección
          </button>
        </div>
        <div class="col-lg-6">
          <button
            v-if="enviandoACore"
            disabled
            class="btn boton-primario w-100"
            style="height: 50px"
          >
            <v-progress-circular
              indeterminate
              size="30"
              color="primary"
            ></v-progress-circular>
          </button>
          <button
            v-else
            style="height: 50px"
            class="btn boton-primario w-100"
            @click.prevent="EnviarACore()"
          >
            Aprobar y enviar a CORE
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Componentes
import axios from "axios";
import servicios from "../../../servicios/service.js";
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";
import ModalPdf from "../components/ModalPdf.vue";

import TituloSeccion from "../../../Componentes/TituloSeccion.vue";

const rutaCargarArchivosExpedienteProspecto =
  "/api/Master/IntegracionExpediente/CargarArchivosCompobantePagoParaValidacionProspecto";
const rutaGuardarObservacionArchivo =
  "/api/Master/PreAutorizacion/GuardarObservacionArchivoComprobante";
const rutaConsultarObservacionArchivo =
  "/api/Master/PreAutorizacion/ConsultarObservacionArchivo";
const rutaEliminarObservacionArchivo =
  "/api/Master/PreAutorizacion/EliminarObservacion";
const rutaDescargarArchivo = "/api/Master/Archivo/DescargarArchivo";

const rutaListarMotivosCancelacionPreAutorizacion =
  "/api/Master/Cancelacion/ListarMotivosCancelacionPreAutorizacion";

const rutaRechazarComprobante =
  "/api/Master/PreAutorizacion/RechazarComprobantePagoYEnviarACorreccion";

const rutaEnviarACore = "/api/Master/PreAutorizacion/EnviarACore";
const rutaEnviarACoreAdicionales =
  "/api/Master/PreAutorizacion/EnviarACoreAdicionales";
const rutaVerArchivo = "/api/Master/Archivo/VerArchivo";
const rutaObtenerFiguraAdicional =
  "/api/Master/FiguraAdicional/ListarFiguraAdicional";
const rutaDescargaPdfComprobantePago =
  process.env.VUE_APP_PAGOS_MIT + "/DescargaPdfComprobantePago";
const rutaObtenerReferenciaPagoEnLinea =
  "/api/Master/SolicitudInscripcion/ObtenerReferenciaPagoEnLinea";

export default {
  name: "ValidarPago",
  components: {
    TituloSeccion,
    ModalPdf,
  },
  mixins: [mixinSolicitudInscripcion],
  mounted() {
    this.ProspectoId = this.$store.getters.prospectoId;
    this.cargarArchivosExpedienteProspecto()
      .then(() => {
        if (this.ArchivosExpediente.length === 0) {
          this.obtenerReferenciaPagoEnLinea(this.ProspectoId).then(() => {
            this.descargaPdfComprobantePago(this.referenciaPago);
          });
        }
      })
      .catch((e) => {
        this.ManejarExcepcion(e);
      });
    this.tipoUsuario = parseInt(sessionStorage.getItem("tipoUsuario"));
    this.ConsultarSolicitudes(this.ProspectoId, false);
    this.ListarFigurasAdicionales(this.ProspectoId, this.tipoPersona);
  },
  data() {
    return {
      tipoUsuario: null,
      ProspectoId: null,
      tieneAdicionales: false,
      adicionalesEnviadosCore: 0,
      figuras: [],
      ArchivosExpediente: [],
      archivorechazado: {
        id: null,
        rechazado: false,
      },
      Observacion: {
        entidadId: null,
        entidadObservacion: null,
        motivoObservacion: "",
        fechaObservacion: null,
        feechaCorrecion: null,
        activo: false,
      },
      ObservacionArchivo: null,
      motivosCancelacion: [],
      motivoCancelacion: null,
      motivoId: null,
      SolicitudId: null,
      urlPdf: null,
      enviandoObservacion: false,
      enviandoACore: false,
      rechazandoComprobante: false,
      comprobantePagoCliente: {
        comprobatePagoPdf: {
          nombreCliente: "",
          reference: "",
          foliocpagos: "",
          auth: "",
          fecha: "",
          nb_company: "",
          nb_merchant: "",
          cc_type: "",
          amount: "",
          cc_mask: "",
          promocion: "",
          cuentaBancaria: "",
        },
        fileContent: "",
        contentType: "",
        fileName: "",
      },
      referenciaPago: "",
      cargandoInfoPago: false,
    };
  },
  methods: {
    VerArchivo(archivoId) {
      this.urlPdf =
        window.location.origin + rutaVerArchivo + "?archivoId=" + archivoId;
    },
    descargarTodosLosArchivos() {
      this.ArchivosExpediente.forEach((value, index) => {
        setTimeout(() => {
          window.location.href =
            rutaDescargarArchivo + "?archivoId=" + value.archivoId;
        }, index * 1000);
      });
    },
    async cargarArchivosExpedienteProspecto() {
      this.cargandoInfoPago = true;
      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      try {
        const resp = await axios.get(
          rutaCargarArchivosExpedienteProspecto,
          parametroProspectoId
        );
        if (resp.data.estado === 0) {
          this.ArchivosExpediente = resp.data.data;
        } else if (resp.data.estado === 1) {
          this.AlertaEmbajadores(resp.data.mensaje, true);
        }
      } catch (e) {
        this.ManejarExcepcion(e);
      } finally {
        this.cargandoInfoPago = false;
      }
    },
    listarMotivosCancelacion() {
      axios
        .get(rutaListarMotivosCancelacionPreAutorizacion)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.motivosCancelacion = resp.data.data;
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    rechazarComprobanteYEnviarACorreccion() {
      this.$fire({
        title: "Rechazar Pago",
        text: "Esta a punto de rechazar el pago, ¿Desea continuar?",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.rechazandoComprobante = true;
          axios
            .post(rutaRechazarComprobante + "?prospectoId=" + this.ProspectoId)
            .then((resp) => {
              this.rechazandoComprobante = false;
              if (resp.data.estado === 0) {
                this.$router.push({
                  name: "AdministracionDeProspectos",
                });
              } else if (resp.data.estado === 1) {
                this.rechazandoComprobante = false;
                this.AlertaEmbajadores(resp.data.mensaje, true);
              }
            })
            .catch((e) => {
              this.rechazandoComprobante = false;
              this.ManejarExcepcion(e);
            });
        }
      });
    },
    ListarFigurasAdicionales(prospectoId, tipoPersona) {
      const parametroProspecto = {
        params: {
          prospectoId: prospectoId,
          tipoPersona: tipoPersona,
        },
      };
      axios
        .get(rutaObtenerFiguraAdicional, parametroProspecto)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.figuras = resp.data.data;
            if (this.figuras.length > 0) {
              this.tieneAdicionales = true;
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje);
          } else {
            this.AlertaEmbajadores(resp.data.mensaje);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    EnviarACore() {
      this.$fire({
        title: "Aprobar Pago",
        text: "¿Desea aprobar el pago?",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.enviandoACore = true;
          axios
            .post(
              rutaEnviarACore +
                "/?prospectoId=" +
                this.ProspectoId +
                "&solicitudId=" +
                this.SolicitudId +
                "&aplicacionId=0" +
                "&modoPago=1" +
                "&admin=1"
            )
            .then((resp) => {
              if (resp.data.estado === 0) {
                this.AlertaEmbajadores(resp.data.mensaje, true);
                this.$router.push({
                  name: "AdministracionDeProspectos",
                });
              } else if (resp.data.estado === 1) {
                this.enviandoACore = false;
                this.AlertaEmbajadores(resp.data.mensaje, true);
                this.$router.push({
                  name: "AdministracionDeProspectos",
                });
              }
            })
            .catch((e) => {
              this.enviandoACore = false;
              this.ManejarExcepcion(e);
            });
        }
      });
    },
    EnviarACoreAdicionales(prospectoId, tipoFigura) {
      if (tipoFigura == 4 || tipoFigura == 5) {
        axios
          .post(rutaEnviarACoreAdicionales + "/?prospectoId=" + prospectoId)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.adicionalesEnviadosCore++;
            } else if (resp.data.estado === 1) {
              this.mensajes.push(resp.data.mensaje);
              if (
                this.figuras.filter((figura) => figura.prospectoId > 0)
                  .length ===
                this.mensajes.length - 1
              ) {
                this.AlertaEmbajadores(this.mensajes.join("\n\n"), true);
              }
              this.adicionalesEnviadosCore--;
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
            return false;
          });
      }
      this.adicionalesEnviadosCore++;
    },
    descargarArchivo(archivoId) {
      window.location.href = rutaDescargarArchivo + "?archivoId=" + archivoId;
    },
    RechazarArchivo(archivoId) {
      this.Observacion.entidadId = archivoId;
      this.Observacion.entidadObservacion = 0;
      this.Observacion.activo = true;
      this.ObtenerObservacionArchivo(archivoId, 0);
    },
    EnviarObservacionArchivo() {
      this.enviandoObservacion = true;
      this.Observacion.fechaObservacion = servicios.DarFormatoFecha(
        new Date(this.Observacion.fechaObservacion)
      );
      axios
        .post(rutaGuardarObservacionArchivo, this.Observacion)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.enviandoObservacion = false;
            this.cargarArchivosExpedienteProspecto();
            this.$refs["botoncerrarObservacion"].click();
            this.ObservacionArchivo != null
              ? this.AlertaEmbajadores("Observación enviada.", true)
              : this.AlertaEmbajadores("Observación actualizada.", true);
          } else if (resp.data.estado === 1) {
            this.enviandoObservacion = false;
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.enviandoObservacion = false;
          this.ManejarExcepcion(e);
        });
    },
    LimpiarCamposModal() {
      this.Observacion.motivoObservacion = "";
      this.ObservacionArchivo = null;
    },
    ObtenerObservacionArchivo(archivoId, tipoEntidad) {
      const archivo = {
        params: {
          entidadId: archivoId,
          tipoEntidad: tipoEntidad,
        },
      };
      axios
        .get(rutaConsultarObservacionArchivo, archivo)
        .then((resp) => {
          if (resp.data.estado === 0) {
            if (resp.data.data === null) {
              this.Observacion.motivoObservacion = "";
              this.ObservacionArchivo = null;
            } else {
              this.Observacion.motivoObservacion = resp.data.data.resultado;
              this.ObservacionArchivo = resp.data.data.resultado;
            }
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    AprobarArchivo(entidadId, tipoEntidad) {
      axios
        .post(
          rutaEliminarObservacionArchivo +
            "?entidadId=" +
            entidadId +
            "&tipoEntidad=" +
            tipoEntidad
        )
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.cargarArchivosExpedienteProspecto();
            this.AlertaEmbajadores("El archivo ha sido aprobado.", true);
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },

    descargarPdf(fileContent, fileName) {
      // Decodificar la cadena Base64 en un ArrayBuffer
      const binaryString = window.atob(fileContent);
      const length = binaryString.length;
      const arrayBuffer = new ArrayBuffer(length);
      const uintArray = new Uint8Array(arrayBuffer);

      for (let i = 0; i < length; i++) {
        uintArray[i] = binaryString.charCodeAt(i);
      }

      // Crear un Blob a partir del ArrayBuffer
      const blob = new Blob([arrayBuffer], { type: "application/pdf" });

      // Crear una URL del Blob para la descarga
      const url = window.URL.createObjectURL(blob);

      // Crear un elemento <a> para iniciar la descarga
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = fileName; // Nombre del archivo
      document.body.appendChild(a);

      // Simular un clic en el elemento <a> para iniciar la descarga
      a.click();

      // Liberar la URL del Blob
      window.URL.revokeObjectURL(url);
    },
    formatoFecha(valor) {
      const fechaHoraString = valor;
      const dividirFechaHora = fechaHoraString.split(" ");
      const fechaString = dividirFechaHora[0];
      return fechaString;
    },
    formatoMoneda(valor) {
      return `$${new Intl.NumberFormat("en-ES").format(valor)}`;
    },
    async obtenerReferenciaPagoEnLinea(propectoId) {
      this.cargandoInfoPago = true;
      try {
        const resp = await axios.get(
          `${rutaObtenerReferenciaPagoEnLinea}?prospectoId=${propectoId}`
        );
        this.referenciaPago = resp.data.data;
      } catch (e) {
        this.ManejarExcepcion(e);
      } finally {
        this.cargandoInfoPago = false;
      }
    },
    async descargaPdfComprobantePago(referenciaPago) {
      this.cargandoInfoPago = true;
      try {
        const resp = await axios.get(
          `${rutaDescargaPdfComprobantePago}/${referenciaPago}`
        );
        this.comprobantePagoCliente = resp.data;
      } catch (e) {
        this.ManejarExcepcion(e);
      } finally {
        this.cargandoInfoPago = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";

.validar-pago {
  width: 100vw;
  flex-grow: 1;
}

/*Modal observación*/
.modal-header {
  border-bottom: none;
  display: flex;
  justify-content: center;
  padding-bottom: -5px;
}
.modal-body {
  padding-bottom: -5px;
}
.modal-footer {
  border-top: none;
  justify-content: center;
  padding-top: -5px;
}
.modal-footer button {
  width: 40%;
}
.modal-dialog {
  max-width: 50%;
}
.modal-content {
  border-radius: 0px;
  border: 1px solid #707070 !important;
}
.header-observacion {
  text-align: center;
}
.texto-observacion {
  font-family: $poppins;
  color: $negro-embajadores;
  text-align: justify;
}
.titulo-observacion {
  font-family: $poppins;
  text-align: center;
  color: #000000;
  font-weight: 700;
}
.boton-cancelar-obs {
  width: 50%;
  border-radius: 0px !important;
  border: 1px solid $color-primario !important;
  background-color: $blanco !important;
  color: #707070 !important;
  font-family: $poppins !important;
  font-size: 16px !important;
}
.obs-actual {
  font-family: $poppins;
}
.encabezado-tabla-comprobante {
  font-family: $poppins;
  font-weight: 400;
  font-size: 16px;
  border-bottom: 1px solid $color-primario !important;
}
.texto-tabla-comprobante {
  font-family: $poppins;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
}
@media all and (max-width: 767px) {
  .modal-dialog {
    max-width: 80%;
    margin-left: 10%;
  }
  .titulo-observacion {
    font-size: 16px;
  }
  .texto-observacion {
    font-size: 13px;
  }
  .boton-cancelar-obs {
    font-size: 14px;
  }
  .boton-aceptar-obs {
    font-size: 14px;
  }
  .obs-actual {
    font-size: 14px;
    font-weight: 700;
  }
}

.icono-obs {
  color: rgb(236, 213, 0);
}
tbody,
td,
tfoot,
th,
tr {
  border-style: none !important;
}
</style>
